import { Timezone_Location_Enum } from 'types/generated/client';

const WALLSTREET_TIMEZONE = 'America/New_York';

// Resolve an IANA timezone string from the user's saved `timezoneLocation`
// preference. `Wallstreet` always maps to America/New_York. `Current` (or any
// unknown value) uses the browser's resolved IANA zone, falling back to ET on
// the server / when Intl is unavailable.
export default function resolveUserTimezone(
  timezoneLocation: Timezone_Location_Enum | null | undefined,
): string {
  if (timezoneLocation === Timezone_Location_Enum.Wallstreet) return WALLSTREET_TIMEZONE;
  if (typeof Intl !== 'undefined') {
    const local = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (local) return local;
  }
  return WALLSTREET_TIMEZONE;
}
